/* eslint-disable camelcase */
/* eslint-disable react/react-in-jsx-scope */
import { createContext, useEffect, useReducer, useContext } from 'react'
import { whoIamService, loginService, createAccount } from './../services/auth.service'
import { GeneralContext } from './general.context'

const initialState = {
  isAuthenticated: false,
  isInitialized: false,
  user: null
}

const handlers = {
  INITIALIZE: (state, action) => {
    const { isAuthenticated, user } = action.payload
    return {
      ...state,
      isAuthenticated,
      isInitialized: true,
      user
    }
  },
  LOGIN: (state, action) => {
    const { user } = action.payload
    return {
      ...state,
      isAuthenticated: true,
      user
    }
  },
  LOGOUT: (state) => ({
    ...state,
    isAuthenticated: false,
    user: null
  }),
  // REGISTERED: (state, action) => {
  //   const { user } = action.payload
  //   return {
  //     ...state,
  //     isAuthenticated: true,
  //     user
  //   }
  // },
  UPDATE_USER: (state, action) => {
    const { user } = action.payload
    return {
      ...state,
      user
    }
  }
}

const reducer = (state, action) => (handlers[action.type]
  ? handlers[action.type](state, action)
  : state)

export const AuthContext = createContext({
  ...initialState,
  login: () => Promise.resolve(),
  logout: () => Promise.resolve()
  // registerAccount: () => Promise.resolve()
})

export const AuthProvider = (props) => {
  const [state, dispatch] = useReducer(reducer, initialState)
  const { children } = props
  const { setIsLoading } = useContext(GeneralContext)

  useEffect(() => {
    const initialize = async () => {
      try {
        setIsLoading(true)
        const token = window.localStorage.getItem('TOKEN_RARR')
        if (token) {
          try {
            const user = await whoIamService(token)
            setIsLoading(false)
            dispatch({
              type: 'INITIALIZE',
              payload: {
                isAuthenticated: true,
                user: { ...user }
              }
            })
          } catch (error) {
            console.log(error)
            setIsLoading(false)
            dispatch({
              type: 'LOGOUT'
            })
            window.localStorage.removeItem('TOKEN_RARR')
          }
          setIsLoading(false)
        } else {
          setIsLoading(false)
          dispatch({
            type: 'LOGOUT'
          })
        }
      } catch (err) {
        setIsLoading(false)
        dispatch({
          type: 'LOGOUT'
        })
        window.localStorage.removeItem('TOKEN_RARR')
      }
    }
    initialize()
  }, [])

  const login = async (credentials, setIsLoading, setErrorMessage) => {
    try {
      // Get token from credentials and set it on local storage
      const token = credentials.accessToken
      localStorage.setItem('TOKEN_RARR', token)
      // Verify if user already exists
      const userInfo = await loginService(credentials)
      if (userInfo) {
        // Verify user's role if exists
        const user = await whoIamService(token)
        dispatch({
          type: 'LOGIN',
          payload: {
            user
          }
        })
        setIsLoading(false)
      }
    } catch (error) {
      console.log(error)
      setErrorMessage(error.message)
    }
  }

  // const registerAccount = async (account) => {
  //   const { token } = await createAccount(account)
  //   const user = await whoIamService(token)
  //   localStorage.setItem('TOKEN_RARR', token)
  //   dispatch({
  //     type: 'REGISTERED',
  //     payload: {
  //       user
  //     }
  //   })
  // }

  const logout = async () => {
    localStorage.removeItem('TOKEN_RARR')
    dispatch({ type: 'LOGOUT' })
  }

  const updateUserContext = async () => {
    const user = await whoIamService(localStorage.getItem('TOKEN_RARR'))
    dispatch({
      type: 'UPDATE_USER',
      payload: {
        user
      }
    })
  }

  const values = {
    ...state,
    login,
    logout,
    updateUserContext
    // registerAccount
  }

  return (
    <AuthContext.Provider
      value={values}
    >
      {children}
    </AuthContext.Provider>
  )
}
